import React from "react"
import { Link } from "gatsby"
export default () => (
  <div style={{ color: `purple` }}>
    <Link to="/">Home</Link>
    <Link to="/about/">About</Link>
    <p>What a world.</p>

  </div>
)